/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */
import {
    ISymbolNewStateTransitionConfig,
    ISymbolOldStateTransitionConfig,
    ISymbolStateConfig,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";

export class BasicStateReelSymbol extends StateReelSymbol {

    private _idleEffectSprite:PIXI.Sprite | null;
    private _idleEffectSpine:PIXI.spine.Spine | null;

    private _symWinLoop:TimelineSprite | null;

    private _isRemovedFromReel:boolean = false;

    private _blurFilter:PIXI.filters.BlurFilter | null;
    private _satFilter:PIXI.filters.ColorMatrixFilter | null;

    private _isWin:boolean = false;
    private _isMobile:boolean = false;


    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations() {
        this._isMobile = UserAgent.isMobile;

        if(!this._idleEffectSprite && !this._idleEffectSpine && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "S", "W"].indexOf(this.symName) > -1) {

            //this.tmpDebugHandler();
            //if (this._idleEffectSpine && ["M1","M2", "M3", "M4", "L1", "L2", "L3", "L4", "S", "W"].indexOf(this.symName) > -1) {
            //if(this._startState && this._startState.keyword !== "spin") {
            // this.playSpineAnimation(this.symName, this.symName + "-spinStart", false, 10);
            //}
            //}
        }

        if(!this._symWinLoop && this.symName !== "S") {
            if(this.symName.indexOf("L") > -1) {
                this.createSymWinLoop(0.65);
            } else {
                this.createSymWinLoop(((this.symName === "M1") ? 0.95 : undefined));
            }
        }
    }

    public set setIsRemovedFromReel(value:boolean | false) {
        this._isRemovedFromReel = value;
    }

    public get isRemovedFromReel():boolean | false {
        return this._isRemovedFromReel;
    }

    private createSymWinLoop(scale:number = 0.85):void {
        const tls:TimelineSprite = new TimelineSprite(GameResources.getTextures("symWinLoop"));
        tls.anchor.set(0.525, 0.5);
        tls.scale.set(scale, scale);
        tls.name = "symWinLoop";
        tls.blendMode = PIXI.BLEND_MODES.SCREEN;
        //tls.playLoop();
        tls.hide();
        this._symWinLoop = tls;
        //this._symWinLoop.playLoop();
        this.addChildAt(this._symWinLoop, 0);
    }

    private tmpDebugHandler():void {
        const ref = this;
        let counter:number = 0;
        let saturation:number = 0.0;
        const anims:string [] = [
            "-spinStart",
            "-spinEnd",
            "-win",
            "-beamOut"
        ];


        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 48:
                    if(ref._idleEffectSpine && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(ref.symName) > -1) {

                        if(ref.symName === "S") {
                            ref.playSpineAnimation(ref.symName, ref.symName + "-idle", true, 0.65);
                        } else {
                            ref.playSpineAnimation(ref.symName, ref.symName + "-idle", true, 0.3);
                        }
                    }
                    break; // 0
                case 57:
                    if(ref._idleEffectSpine && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(ref.symName) > -1) {
                        if(counter > 3) {
                            counter = 0;
                        }

                        if(saturation > 1) {
                            saturation = 0;
                        } else {
                            saturation += 0.10;
                        }

                        if(["M1", "M2", "M3", "M4"].indexOf(ref.symName) > -1 && ref._idleEffectSpine) {
                            const filter:PIXI.filters.ColorMatrixFilter = new PIXI.filters.ColorMatrixFilter();

                            ref._idleEffectSpine.filters = [filter];
                            filter.saturate(saturation, true);
                            console.log("SATURATION Value: " + saturation);
                        }

                        /*if(anims[counter] === "-beamOut") {
                            if(["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "S"].indexOf(ref.symName) > -1) {
                                ref.playSpineAnimation(ref.symName, ref.symName + anims[counter], false, 1);
                            }
                            counter++;
                        }
                        else {
                            ref.playSpineAnimation(ref.symName, ref.symName + anims[counter], false, 1);
                            counter++;
                        }*/
                    }
                    break; // 9
            }
        }, false);
    }

    public removeNoWinBlur():void {
        if(this._idleEffectSpine) {
            this._idleEffectSpine.tint = 0xFFFFFF;

            TweenLite.to(this._idleEffectSpine.scale, 0.1, {
                x : 1,
                y : 1
            });
            if(this._blurFilter) {
                TweenLite.to(this._blurFilter, 0.1, {
                    blur : 0
                });
            }
        }
    }

    public playSpineAnimation(symName:string, animationName:string, loop:boolean, timeScale:number = 1, onEnd:(trackEntry:PIXI.spine.core.TrackEntry) => void = () => {}):void {
        if(this._idleEffectSpine && this._idleEffectSpine.state && this.symName === symName) {
            if(animationName.indexOf("-beamOut") > 0) {
                this.removeNoWinBlur();
            }

            this._idleEffectSpine.visible = true;
            this._idleEffectSpine.state.timeScale = timeScale;
            this._idleEffectSpine.state.setAnimation(0, animationName, loop);
            this._idleEffectSpine.stateData.setMix(this.symName + "-spinStart", this.symName + "-spinEnd", 0.05);

            this._idleEffectSpine.state.addListener({
                //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                complete : (entry) => onEnd(entry),
                //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
            });
        }
    }

    public showNormalTexture():void {
        (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
            sprite!.visible = false;
        });
        const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("panelSym-" + this.symName)[0]);
        sprite.anchor.set(0.5, 0.5);
        sprite.name = "spinToNormal";
        this.addChild(sprite);
    }

    public hideSpineLayer():void {
        if(this._idleEffectSpine && this._idleEffectSpine.state) {
            (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
                if(sprite!.name !== "idle") {
                    sprite!.visible = true;
                }
            });

            if(["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(this.symName) > -1) {
                (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
                    if(sprite!.name !== "idle" && sprite!.name !== "symWinLoop") {
                        sprite!.visible = false;
                    }
                });
                this.playSpineAnimation(this.symName, this.symName + "-beamOut", false, 1);
            } else {
                this._idleEffectSpine.visible = false;
            }

            if(this._symWinLoop) {
                this._symWinLoop.hide();
            }
        }
    }

    changeState(newStateConfig:ISymbolNewStateTransitionConfig, oldStateConfig?:ISymbolOldStateTransitionConfig):Timeline | null {
        const tl:Timeline | null = super.changeState(newStateConfig, oldStateConfig);

        if(tl !== null) {
            if(this.currentState && this.currentState.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.spin.keyword) {
                tl.add(() => {
                    if(this.currentState && this.currentState.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.spin.keyword) {
                        if(this._idleEffectSpine && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(this.symName) > -1) {
                            if(this.symName === "S") {
                                this.playSpineAnimation(this.symName, this.symName + "-spinStart", false, 10);
                            }
                        }
                    }
                });
            }
        }

        return tl;
    }

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        if(!this.isRemovedFromReel) {
            super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        }

        if(this.currentState && this.currentState.keyword === "spin" && this.symName !== "S") {
        } else if(!this._idleEffectSprite) {
            this.createIdleSpine();
        }

        if(this.currentState && this.currentState.keyword === "spin" && newState.state.keyword === "normal" && !this._idleEffectSprite) {

            timeline.add(() => {
                this.createIdleSpine();
                new TimelineLite().add(() => {
                    (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
                        if(sprite!.name !== "idle" && sprite!.name !== "symWinLoop") {
                            sprite!.visible = false;
                        }
                    });
                }, 0.15);
            });
        }

        if(this._idleEffectSpine) {
            this._idleEffectSpine.tint = 0xFFFFFF;
            if(this._idleEffectSpine.scale.x < 1) {

                TweenLite.to(this._idleEffectSpine.scale, 0.3, {
                    x : 1,
                    y : 1
                });
                if(this._blurFilter) {
                    TweenLite.to(this._blurFilter, 0.3, {
                        blur : 0
                    });
                }

            }
        }


        // TODO: is this even valid?
        if((this.currentState && this.currentState.keyword !== TractorBeamGameConfig.instance.SYMBOL_STATES.win.keyword) && this._symWinLoop) {
            if(this._symWinLoop.visible) {
                this._symWinLoop.hide();
                this._symWinLoop.stopLoop();
            }
        }


        if(newState.state.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.win.keyword && (this.currentState && this.currentState.keyword !== TractorBeamGameConfig.instance.SYMBOL_STATES.win.keyword)) {
            const winTl:TimelineLite = new TimelineLite();
            if(this._idleEffectSpine && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(this.symName) > -1) {
                winTl.add([
                    () => this.playSpineAnimation(this.symName, this.symName + "-win", false, 1)
                ]);
            }
            if(this.symName !== "S") {
                winTl.add(() => {
                    if(this._symWinLoop) {
                        if(!this._symWinLoop.visible) {
                            this._symWinLoop.show();
                            this._symWinLoop.playLoop();
                        }
                    }
                });
            }
            this._isWin = true;

            timeline.add(winTl, delay);
        }

        if(newState.state.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.noWin.keyword && !this._isWin) {
            if(this._idleEffectSpine) {
                timeline.add(() => {
                    if(this._idleEffectSpine) {
                        const blurFilter:PIXI.filters.BlurFilter = new PIXI.filters.BlurFilter(0, 2);
                        if(this._satFilter && !this._isMobile) {
                            this._idleEffectSpine.filters = [blurFilter, this._satFilter];
                        } else {
                            this._idleEffectSpine.filters = [blurFilter];
                        }


                        this._blurFilter = blurFilter;
                        TweenLite.fromTo(blurFilter, 0.2, {
                            blur : 0
                        }, {
                            blur : 4
                        });
                        TweenLite.fromTo(this._idleEffectSpine.scale, 0.2, {
                            x : 1,
                            y : 1
                        }, {
                            x : 0.85,
                            y : 0.85
                        });

                        this._idleEffectSpine.tint = 0x7EC0EE;//0x71ACD6;//0x555555;
                    }
                }, delay);
                this._isWin = false;
            } else {
                timeline.add(() => stateAnimation.tint = 0x555555, delay);
            }
        }

        if(["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(this.symName) > -1 && this._idleEffectSprite) {
            this.addChildAt(this._idleEffectSprite, this.children.length - 1);
            (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
                if(sprite!.name !== "idle" && sprite!.name !== "symWinLoop" && sprite!.name !== "spriteToNormal") {
                    sprite!.visible = false;
                }
                if(this._idleEffectSprite) {
                    this._idleEffectSprite.visible = true;
                }
            });
        }

        if(this._idleEffectSpine && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(this.symName) > -1 && newState.state.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            if(this._symWinLoop && this._symWinLoop.visible) {
                TweenLite.fromTo(this._symWinLoop, 0.4, {
                    alpha : 1
                }, {
                    alpha : 0
                }).eventCallback('onComplete', () => {
                    if(this._symWinLoop) {
                        this._symWinLoop.hide();
                        this._symWinLoop.stopLoop();
                        this._symWinLoop.alpha = 1;
                    }
                });

            }
            //timeline.add(() => {
            // Handled in reel controller
            //this.playSpineAnimation(this.symName, this.symName + "-spinStart", false, 2);
            //}, (this.symName === "S")? 1 : 0);
        }

        if(this._idleEffectSpine && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(this.symName) > -1 && newState.state.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.normal.keyword) {

            if(this._currentState && this._currentState.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.spin.keyword) {
                // TODO: Add end handler here?
            } else {
                timeline.add(() => {
                    if(this.symName === "S") {
                        this.playSpineAnimation(this.symName, this.symName + "-idle", true, 0.65);
                    } else {
                        this.playSpineAnimation(this.symName, this.symName + "-idle", true, 0.3);
                    }

                });
            }
        }
    }

    public getWinAnimation():Timeline {
        const tl = new TimelineMax({
            repeat : 1,
            yoyo : true
        });

        if(this._idleEffectSpine && this._idleEffectSprite) {

            if(["M1", "M2", "M3", "M4"].indexOf(this.symName) > -1) {
                tl.add(TweenLite.fromTo(this._idleEffectSprite.scale, 0.2, {
                    x : 1.1,
                    y : 1.1
                }, {
                    x : 1.2,
                    y : 1.2
                }));
            } else {
                tl.add(TweenLite.fromTo(this._idleEffectSprite.scale, 0.2, {
                    x : 1,
                    y : 1
                }, {
                    x : 1.1,
                    y : 1.1
                }));
            }
        }

        return tl;
    }

    protected addOldStateAnimation(timeline:TimelineLite, transition:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addOldStateAnimation(timeline, transition, stateAnimation, delay);
    }

    protected createIdleSpine(name:string = "", track:number = 0):void { // "M1-spin"
        this._idleEffectSprite = new PIXI.Sprite();
        this._idleEffectSprite.name = "idle";
        this._idleEffectSprite.x = 0;
        this._idleEffectSprite.y = 0;

        this._idleEffectSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(this.symName + "_idle"));
        this._idleEffectSpine.autoUpdate = true;
        this._idleEffectSpine.state.setAnimation(track, this.symName + "-idle", true);

        if(this.symName === "S") {
            this._idleEffectSpine.state.timeScale = 0.65;
        } else {
            this._idleEffectSpine.state.timeScale = 0.3;
        }


        this._idleEffectSprite.addChild(this._idleEffectSpine);

        this._idleEffectSprite.anchor.set(0.5, 0.5);

        if(["M1", "M2", "M3", "M4"].indexOf(this.symName) > -1) {
            this._idleEffectSprite.scale.set(1.1, 1.1);
            const filter:PIXI.filters.ColorMatrixFilter = new PIXI.filters.ColorMatrixFilter();
            this._satFilter = filter;

            if(!this._isMobile) {
                this._idleEffectSpine.filters = [filter];
            }

            filter.saturate(0.4, true);
        } else {
            this._idleEffectSprite.scale.set(1, 1);
        }
        this.addChild(this._idleEffectSprite);
    }
}
